import { LocalStorageAdapter } from '@/infra/adapters/storage/localstorage-adapter';
import { IStorage } from '@/infra/interfaces/storage/storage';

function makeStorage(): IStorage {
  return new LocalStorageAdapter();
}

export const storage = makeStorage();
